import { Routes } from 'src/Routes.constants';
import { SUBSCRIPTION_STATUS } from 'src/common/components/SubscriptionStatus/constants/subscriptionStatus';
import { PRODUCT_TYPE } from '../api/tariffSummaryDTOModels';
import Box from '@mui/material/Box';
import { TableTooltip } from 'common/components/Tooltip/TableTooltip';
import { StickyCopyExtension } from 'src/common/StickyCopyExtension/StickyCopyExtension';
import {
  CellLayout,
  CellLayoutRow,
  CellLayoutPrimaryLinkTypography,
  CellLayoutPrimaryTypography,
} from 'src/common/components/ConfigurableTable/Components/Cells/CellLayout';
import { useTariffAccountRef } from './../../hooks/useTariffAccountRef';
import { useSetAtom } from 'jotai';
import { simProductsSortingAtomWithStorage } from 'src/atoms/filters/sim-products';

type TariffSummaryCodeCellProps = {
  bundleProductCode: string;
  productType: string;
  productCodes: string[];
};

export const TariffSummaryCodeCell = ({
  bundleProductCode,
  productType,
  productCodes,
}: TariffSummaryCodeCellProps) => {
  const accountRef = useTariffAccountRef();

  const setSimSorting = useSetAtom(simProductsSortingAtomWithStorage);
  const shouldRedirect = productType && productCodes.length;
  const redirectToTab =
    productType === PRODUCT_TYPE.RSIM ? Routes.productsRsim : Routes.productsSim;
  const filters = `?productCodes=${productCodes?.join(',')}&subscriptionStatus=${
    SUBSCRIPTION_STATUS.ACTIVE
  }&accounts=${accountRef}`;

  const redirectToURl = shouldRedirect ? redirectToTab + filters : '#';

  return (
    <CellLayout>
      <CellLayoutRow>
        <Box
          onClick={(e) => {
            e.stopPropagation();
            setSimSorting({
              columnName: 'liveDataUsage',
              sort: 'desc',
            });
          }}
        >
          <StickyCopyExtension value={bundleProductCode}>
            <TableTooltip value={bundleProductCode}>
              {shouldRedirect ? (
                <CellLayoutPrimaryLinkTypography to={redirectToURl}>
                  {bundleProductCode}
                </CellLayoutPrimaryLinkTypography>
              ) : (
                <CellLayoutPrimaryTypography>{bundleProductCode}</CellLayoutPrimaryTypography>
              )}
            </TableTooltip>
          </StickyCopyExtension>
        </Box>
      </CellLayoutRow>
    </CellLayout>
  );
};
